var _excluded = ["showInfo", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Progress as AntdProgress } from 'antd';
import useStyles from "./style";
function Progress(_ref) {
  var _ref$showInfo = _ref.showInfo,
    showInfo = _ref$showInfo === void 0 ? false : _ref$showInfo,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    st = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;
  return /*#__PURE__*/React.createElement(AntdProgress, _extends({}, rest, {
    showInfo: showInfo,
    className: cx(st.progressWrap, className, prefixCls + '-aelfd-progress')
  }));
}
export default Progress;